import Skeleton from 'react-loading-skeleton';
import './SmartNewsCard.css';

const SmartNewsCard = ({ loading, error, news }) => {
    if (loading || error || !news) {
        return (
            <li className="important-card skeleton-card">
                <Skeleton 
                baseColor="var(--bg-footer)" 
                highlightColor="var(--bg-body)" 
                height={300} 
                style={{ borderRadius: '0px', marginBottom: '15px', border:'1px solid var(--bg-body)'  }} 
                />

                <Skeleton 
                baseColor="var(--bg-footer)" 
                highlightColor="var(--bg-body)" 
                height={20} 
                width="50%" 
                style={{ borderRadius: '0px', marginBottom: '10px', border:'1px solid var(--bg-body)'  }} 
                />

                <Skeleton 
                baseColor="var(--bg-footer)" 
                highlightColor="var(--bg-body)" 
                height={25} 
                width="80%" 
                style={{ borderRadius: '0px', border:'1px solid var(--bg-body)' }}
                />
            </li>
        );
    }

    return (
        <li 
            key={news.id}
            className="important-card"
            data-aos="fade-up"
        >
            <div className="important-imgWrapper shine-on-hover">
                <img src={news.image} alt={news.title} className="important-img" />
            </div>
            <h6 className='importantNews-date'>
                {news.date}
            </h6>
            <h2 className="importantNews-title">
                {news.title}
            </h2>
        </li>
    );
};

export default SmartNewsCard;
